import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useResponseEditor } from "../response-editor.js";
/* empty css                      */
/* empty css                */
/* empty css                */
/* empty css                  */
const ResponseEditor = (props) => {
  const $ = c(2);
  const ref = useResponseEditor(props, ResponseEditor);
  let t0;
  if ($[0] !== ref) {
    t0 = /* @__PURE__ */ jsx("section", { className: "result-window", "aria-label": "Result Window", "aria-live": "polite", "aria-atomic": "true", ref });
    $[0] = ref;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export {
  ResponseEditor
};
//# sourceMappingURL=response-editor.js.map
